import type React from 'react';

import cn from '../../utils/cn';
import Typography from '../Typography';

interface IProps {
  Icon?: React.FC<React.SVGProps<SVGSVGElement>>;
  text: string;
  children?: React.ReactNode;
  className?: string;
}

export const Placeholder = ({ Icon, text, className = '', children }: IProps) => {
  return (
    <div className={cn('flex flex-col items-center justify-center space-y-2', className)}>
      {Icon && <Icon className='h-16 w-16' />}
      <Typography className='text-center' variant='body'>
        {text}
      </Typography>
      {children}
    </div>
  );
};

export default Placeholder;
